var _ellipse, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 106,
    viewBox: "0 0 108 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 52.5326,
    rx: 54,
    ry: 52.5326,
    fill: "url(#paint0_linear_33_2803)",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9023 78.888C45.9584 78.8491 49.1696 76.4734 49.2239 76.4304C49.5537 76.2031 49.8534 75.9029 50.1034 75.5295L81.4482 28.7316C82.1922 27.2704 80.5821 26.4576 80.6039 26.4763C79.8098 26.0792 78.6186 26.4763 78.6186 26.4763C78.5615 26.5134 78.6723 26.4315 78.6186 26.4763C78.5615 26.5134 76.0705 28.7316 76.0705 28.7316L75.5003 29.3479L46.9819 59.0913L31.4273 50.2686C30.817 49.9223 29.5577 50.4473 29.5577 50.4473C27.0446 51.4612 27.0446 53.0512 27.0446 53.0512C26.9031 53.1435 27.1615 54.1062 27.0443 54.2437L45.9023 78.888Z",
    fill: "#BEBEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3916 54.8131L43.4216 77.9004C44.7384 79.7969 47.2703 79.7574 48.541 77.8204L80.2932 29.4199C80.8652 28.5481 80.7244 27.3142 79.9758 26.6387C79.2875 26.0178 78.3037 26.0706 77.6695 26.7625L46.0896 61.2307L29.6221 51.6942C28.9125 51.2833 28.0504 51.4516 27.5007 52.1088C26.8784 52.8528 26.8319 54.007 27.3916 54.8131Z",
    fill: "#FFFBFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_2803",
    x1: -0.0000131245,
    y1: 52.5328,
    x2: 108,
    y2: 52.5328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008E95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.176b0bf19cfb5dffb6b8c7d5a078347c.svg";
export { ForwardRef as ReactComponent };